import * as React from 'react'
import config from '@/config/config'
import { Link } from 'react-router-dom'
import storageUtils from '@/utils/storageUtils'
// import { message } from 'antd';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import CommonUtils from '../../../utils/commonUtils'
//需要渲染什么数据
function mapStateToProps(state) {
  console.log('state', state)
  return {
    userInfo: state,
  }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
  return {
    PayIncrease: v => dispatch({ type: 'change', value: v }),
  }
}
class List extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      token: JSON.parse(storageUtils.get(config.loginStorageKey)),
      showServiceNav: 'none'
    };
  }
  UNSAFE_componentWillMount() {
    console.log('headerthis.props', this.props);
    console.log('this.props.userInfo.username1', this.props.userInfo.username)
  }

  handleMouseOver = () => {
    if (!(JSON.stringify(this.props.userInfo) === '{}')) {
      this.setState({
        showServiceNav: 'block'
      })
    }

  }

  handleMouseOut = () => {
    this.setState({
      showServiceNav: 'none'
    })
  }
  render() {
    const { PayIncrease } = this.props
    /**
     * 注销
     */
    const logOut = () => {
      // 清空登录信息
      storageUtils.remove(config.loginStorageKey)
      sessionStorage.removeItem("orderDetail");
      PayIncrease(null)
      console.log('window.location.pathname', window.location.pathname)
      this.setState({ token: JSON.parse(storageUtils.get(config.loginStorageKey)) }, () => {
        console.log('window.location.pathname', window.location.pathname)
        if (window.location.pathname === '/case' ||
          window.location.pathname === '/pay' ||
          window.location.pathname === '/service/search' ||
          window.location.pathname === '/personal/account' ||
          window.location.pathname === '/report' ||
          window.location.pathname === '/personal/trade' ||
          window.location.pathname === '/service/result/detail' ||
          window.location.pathname === '/service/result'
        ) {
          this.props.history.push(`/`);
        } else {
          window.location.reload();
        }
      }
      )
    }

    return (
      <div className="index-header">
        <div className="header-content">
          <img src="/img/zheyuan-logo.png" style={{ width: '148px', height: '35px', marginRight: '22px'}} alt="" />
          <div className="name">
            TWiRLs
            <div className="sub-name">棍棍</div>
          </div>
          {/* <a onClick={() => { PayIncrease('测试名字heald'); }}>11111+{this.props.userInfo.username}</a> */}
          <div className="menu">
            <Link
              to="/"
              className={
                'menu-item' +
                (window.location.pathname === '/' ? ' current' : '')
              }
            >
              首页
            </Link>
            {this.state.token && (
              <Link
                to="/case"
                className={
                  'menu-item' +
                  (window.location.pathname === '/case' ? ' current' : '')
                }
              >
                案例
              </Link>
            )}
            {/* {
              !this.state.token &&
              <a className={"menu-item" + (window.location.pathname === '/case' ? ' current' : '')}
                onClick={() => { message.warning('请先登录!') }}
              >案例</a>
            } */}
            {!this.state.token && (
              <Link
                to="/login"
                className={
                  'menu-item' +
                  (window.location.pathname === '/case' ? ' current' : '')
                }
              >
                案例
              </Link>
            )}
            {this.state.token && (
              <Link
                to="/service/search"
                className={
                  'menu-item' +
                  (window.location.pathname.indexOf('/service') >= 0
                    ? ' current'
                    : '')
                }
              >
                服务
              </Link>
            )}
            {/* {
              !this.state.token &&
              <a className={"menu-item" + (window.location.pathname.indexOf('/service') >= 0 ? ' current' : '')}
                onClick={() => { message.warning('请先登录!') }}
              >服务</a>
            } */}
            {
              !this.state.token &&
              <Link to="/login" className={"menu-item" + (window.location.pathname === '/case' ? ' current' : '')}>服务</Link>
            }
            <Link to={this.state.token ? '/pay' : '/login'} className={"menu-item" + (window.location.pathname === '/pay' ? ' current' : '')}>定价</Link>
            <Link to={this.state.token ? '/report' : '/login'} className={"menu-item" + (window.location.pathname === '/report' ? ' current' : '')}>报告中心</Link>
            <Link to="/contactus" className={"menu-item" + (window.location.pathname === '/contactus' ? ' current' : '')}>联系我们</Link>

          </div>
          <div className="login-info">
            <div className="avatar" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
              {
                this.props.userInfo &&
                this.props.userInfo.extendFieldMap &&
                this.props.userInfo.extendFieldMap.avatarUrl && (
                  <img
                    src={
                      this.props.userInfo &&
                        this.props.userInfo.extendFieldMap &&
                        this.props.userInfo.extendFieldMap.avatarUrl
                        ? this.props.userInfo.extendFieldMap.avatarUrl
                        : '/img/index-avatar.png'
                    }
                    alt=""
                    width="25px"
                    style={{ borderRadius: '50%' }}
                  />
                )}
              {(!this.props.userInfo ||
                !this.props.userInfo.extendFieldMap ||
                !this.props.userInfo.extendFieldMap.avatarUrl) && (
                  <img src="/img/index-avatar.png" alt="" />
                )}
              {
                this.state.token && this.state.token.loginInfo &&
                <div className="login-name">
                  {this.state.token.loginInfo.realName}

                  <Link to={"/personal/account"}>
                    {
                      this.props.userInfo.username || CommonUtils.getPhoneShow(this.props.userInfo.mobile, 3, 5) || '个人中心'
                    }
                  </Link>
                  {/* <Link to={"/pay"}>
                    充值中心
                  </Link> */}
                  {/* <a onClick={logOut}>退出</a> */}
                </div>
              }
            </div>
            <div className="service-nav" style={{ display: this.state.showServiceNav }} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
              <Link to={"/personal/account"}>
                账户中心
              </Link>
              {/* <Link to={"/pay"}>
                充值中心
              </Link> */}
              <a onClick={logOut}>退出登录</a>
            </div>
            {/* {
              this.state.token && this.state.token.loginInfo &&
              <div className="login-name">
                {this.state.token.loginInfo.realName}
                &nbsp;&nbsp;
                <Link to={"/personal/account"}>
                  {
                    this.props.userInfo.username || CommonUtils.getPhoneShow(this.props.userInfo.mobile, 3, 5) || '个人中心'
                  }
                </Link>
                <Link to={"/pay"}>
                  充值中心
                </Link>
                <a onClick={logOut}>退出</a>
              </div>
            } */}
            {
              !this.state.token &&
              <React.Fragment>
                <div className="login-name">
                  <Link
                    to={
                      '/login?src=' +
                      encodeURIComponent(
                        window.location.pathname + window.location.search
                      )
                    }
                  >
                    请登录
                  </Link>
                </div>
                <div className="login-name">
                  <Link
                    to={
                      '/Register?src=' +
                      encodeURIComponent(
                        window.location.pathname + window.location.search
                      )
                    }
                  >
                    请注册
                  </Link>
                </div>
              </React.Fragment>
            }
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(List))
